import CarPackageToggle from './CarPackageToggle';
import TravelPackageToggle from './TravelPackageToggle';

type InputComponent = React.ComponentType<{
    isLoading: boolean;
    setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
}>;

const getPackageToggle = (lobCode: string): InputComponent | undefined => {
    switch (lobCode) {
        case 'MVP':
            return CarPackageToggle;
        case 'TRA':
            return TravelPackageToggle;
        default:
            return undefined;
    }
};

export default getPackageToggle;
